export default __webpack_public_path__ + "static/media/near02.a402323e.png";